
import CricketFightRoutes from "@/modules/cricket-fight";
import BetsRoutes from "@/modules/bets";
import GamesRoutes from "@/modules/games";
import MatkaRoutes from "@/modules/matka";
import ProfileRoutes from "@/modules/profile";
import ReferEarnRoutes from "@/modules/refer-earn";
import SportsRoutes from "@/modules/sports";
import WalletRoutes from "@/modules/wallet";
import MyMarketRoutes from "@/modules/my-market";
import NotificationsRoutes from "@/modules/notification";
import AffiliateRoutes from '@/modules/affiliate';
const Faq = () => import("../shared/components/footer/Faq.vue")

import { createRouter, createWebHistory } from "vue-router";
const Home = () => import("../views/Home.vue");
const Login = () => import("@/modules/authorization/components/Login.vue");
const SignUp = () => import("@/modules/authorization/components/SignUp.vue");
const ForgetPassword = () => import("@/modules/authorization/components/ForgetPassword.vue");
const MaintenanceComponent = () => import("@/shared/components/maintenance/Maintainence.vue");

import NotFound from "../shared/components/no-data/404.vue";

const routes = [
    {
      path: '/',
      redirect: '/home'
    },
    {
        path: "/home",
        name: "Home",
        component: Home
    },
    {
        path: "/inplay",
        name: "inplay",
        component: Home
    },
    {
        path: "/login",
        name: "login",
        component: Login
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: SignUp
      },
      {
        path: "/forget-password",
        name: "forget-password",
        component: ForgetPassword
      },
      {
        path: "/faq",
        name: "Faq",
        component: Faq
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: MaintenanceComponent
      },
    SportsRoutes,
    GamesRoutes,
    WalletRoutes,
    MyMarketRoutes,
    ProfileRoutes,
    BetsRoutes,
    ReferEarnRoutes,
    MatkaRoutes,
    CricketFightRoutes,
    AffiliateRoutes,
    NotificationsRoutes,
    { 
      path: '/:pathMatch(.*)*',
      name: 'NotFound', 
      component: NotFound 
    },  
];

export default createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      return { top: 0 };
    },
});
